import { render, staticRenderFns } from "./Сorruption.vue?vue&type=template&id=736fece3&scoped=true&ref=adminUser&"
import script from "./Сorruption.vue?vue&type=script&lang=js&"
export * from "./Сorruption.vue?vue&type=script&lang=js&"
import style0 from "./Сorruption.vue?vue&type=style&index=0&id=736fece3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fece3",
  null
  
)

export default component.exports